<template>
	<div>
		<firstsceen> </firstsceen>
		<!-- ai -->
		<Adbigwordbutton :pagetop="scrolltop" button="查看更多详情" title="C2M智能定制解决方案" subtitle="AI脚型数据扫描+鞋楦匹配算法+C2M高级定制"
			:imgurl="img1" stylemode="blue" hidemb="true" buttonurl='/Solution/Custom'>
		</Adbigwordbutton>
		<!-- ai end-->

		<!-- ai -->
		<Adbigwordbutton :pagetop="scrolltop" button="查看更多详情" title="AI流行趋势" subtitle="用AI准确定位时尚潮流" :imgurl="img2"
			stylemode="white" hidemb="true" buttonurl='/newpro/ProaiLiuxing'>
		</Adbigwordbutton>
		<!-- ai end-->

		<!-- ai -->
		<Adbigwordbutton :pagetop="scrolltop" button="查看更多详情" title="AI数字化材料图书馆" subtitle="用AI专为时尚产业打造数字化材料图书馆"
			:imgurl="img3" stylemode="brown" buttonurl='/newpro/Probookclub'>
		</Adbigwordbutton>
		<!-- ai end-->

		<!-- four ad -->
		<div ref="fourad" class="paddingview" style="background-color: #F8F8F8;">
			<div class="container">
				<div class="row">
					<div class="col-md-5"  @click="gorul('https://www.xlzhixuan.com/#/indexpage/index')">
						<transition name="adfadex1">
							<div v-if="fouradshow" class="adsmalltitleview" style="height: 743px;"
								:style="{backgroundImage:`url(${bakimg1 })`}">
								<div class="adsmalltitle colorfff" >
									 星链供应链服务（订货平台） 
								</div>
								<div class="colorfff"
									style=" letter-spacing: 3px; margin-top: 16px;font-size: 14px; opacity: 0.5;">
									一站式鞋履供应链平台
								</div>
							</div>
						</transition>
					</div>
					<div class="col-md-7 ">
						<div class="flexrowreverse" style="height: 743px;">
							<transition name="adfadex2">
								<div v-if="fouradshow" class="adsmalltitleview" style="height: 200px;"
									:style="{backgroundImage:`url(${bakimg2})`}">
									<div class="adsmalltitle colorfff">工业互联网</div>
									<div class="colorfff"
										style=" letter-spacing: 3px; margin-top: 16px;font-size: 14px; opacity: 0.5;">
										用AI让制造更高效，为工业强国贡献星链力量
									</div>
								</div>
							</transition>
							<transition name="adfadex2">
								<div v-if="fouradshow2" class="adsmalltitleview" style="height: 315px;"
									:style="{backgroundImage:`url(${bakimg3})`}">
									<div class="adsmalltitle colorfff">
										AI辅助设计平台
									</div>
									<div class="colorfff"
										style=" letter-spacing: 3px; margin-top: 16px;font-size: 14px; opacity: 0.5;">
										3D渲染，逼真还原设计
									</div>
								</div>
							</transition>

							<transition name="adfadex2">
								<div v-if="fouradshow3" class="adsmalltitleview" style="height: 170px;"
									:style="{backgroundImage:`url(${bakimg4})`}">
									<div class="adsmalltitle ">手持3D数据扫描</div>
									<div style=" letter-spacing: 3px; margin-top: 16px;font-size: 14px; opacity: 0.5;">
										基于光学图像三维重建技术的3D扫描技术
									</div>
								</div>
							</transition>
							<!-- 保证有3个元素 不影响布局 -->
							<div v-show="!fouradshow3" style="height: 170px;">

							</div>
							<!-- 保证有3个元素 不影响布局 end -->
						</div>

					</div>
				</div>
			</div>
		</div>
		<!-- four ad  end -->

		<!-- ai -->
		<!-- stylemode="brown" -->
		<Adbigwordbutton :pagetop="scrolltop" hidemb="true" title="数字成就美好生活" subtitle="Digital makes a better life"
			:imgurl="img4">
		</Adbigwordbutton>
		<!-- ai end-->

		<!-- new -->
		<div ref="news">
			<Adword title="新闻与活动" slotheight="500">
				<!-- <div class="container"> -->
					<div class="flexcenter">
						<transition name="adfadey1">
							<!--  class="col-12 col-sm-6 col-md-6 col-lg-3  col-xl-3" -->
							<div v-if="newsshow1" style="margin-bottom: 30px;">
								<div class="boxshadow" style="height: 463px;width: 310px;"
									v-on:click="gopage('/news/details/1')">
									<div>
										<img style="width: 100%; height:210px;"
											src="../static/news/鞋业“奥斯卡”落户上海CHIC 奥云数据荣获“年度鞋履产业创新者”大奖.png">
									</div>
									<div style="padding: 18px 38px 18px 38px;">
										<div class="line-clamp2"
											style="font-size: 16px;color: #333333;  text-align: center;margin-bottom:14px ;font-weight: bold;line-height:24px">
											鞋业“奥斯卡”落户上海CHIC 奥云数据荣获“年度鞋履产业创新者”大奖</div>
										<div class="line-clamp3"
											style="font-size: 14px; color: #666666; margin-bottom:30px ;line-height: 150%;font-weight: 400;">
											2021年3月17日，2021CHIC中国服装服饰博览会在中国上海国家会展中心盛大开展。本次展会上CHIC展会和《Footwear
											News》杂志联合举办了中国鞋履成就奖颁奖盛典，NIKE（耐克）、FILA（斐乐）、李宁、特步、百丽等国际知名鞋企获得提名，其中，温州新生代创新型科技公司奥云数据成为本次盛典的一大亮点。
										</div>
										<div class="cc"
											style="font-size: 11px; color: #999999; background-color: #F8F8F8; margin-left: auto; margin-right: auto; height: 30px;width: 78px; border: 1px solid #999999;">
											行业资讯
										</div>
									</div>
								</div>
							</div>
						</transition>
						<div style="width: 10px;height: 1px;"></div>
						<transition name="adfadey1">
							<div v-if="newsshow2" style="margin-bottom: 30px;">
								<div class="boxshadow" style="height: 463px;width: 310px;"
									v-on:click="gopage('/news/details/2')">
									<div>
										<img style="width: 100%; height:210px;"
											src="../static/news/新战略·星启程星链数据2021年度成绩单.png">
									</div>
									<div style="padding: 18px 38px 18px 38px;">
										<div class="line-clamp2"
											style="font-size: 16px;color: #333333;  text-align: center;margin-bottom:14px ;font-weight: bold;line-height:24px">
											新战略·星启程星链数据2021年度成绩单</div>
										<div class="line-clamp3"
											style="font-size: 14px; color: #666666; margin-bottom:30px ;line-height: 150%;font-weight: 400;">
											充满机遇和挑战的2021年，也是星链硕果满满的一年。1月24日，星链[新征程·星启航]年度工作述职会议在奥康知行厅展开，为2021年画上圆满的句号。
										</div>
										<div class="cc"
											style="font-size: 11px; color: #999999; background-color: #F8F8F8; margin-left: auto; margin-right: auto; height: 30px;width: 78px; border: 1px solid #999999;">
											行业资讯
										</div>
									</div>
								</div>
							</div>
						</transition>
						<div style="width: 10px;height: 1px;"></div>
						<transition name="adfadey1">
							<div v-if="newsshow3" style="margin-bottom: 30px;">
								<div class="boxshadow" style="height: 463px;width: 310px;"
									v-on:click="gopage('/news/details/3')">
									<div>
										<img style="width: 100%; height:210px;"
											src="../static/news/星链联合华为共同助力中国时尚产业数字化.png">
									</div>
									<div style="padding: 18px 38px 18px 38px;">
										<div class="line-clamp2"
											style="font-size: 16px;color: #333333;  text-align: center;margin-bottom:14px ;font-weight: bold;line-height:24px">
											星链C2M赋能鞋业突围</div>
										<div class="line-clamp3"
											style="font-size: 14px; color: #666666; margin-bottom:30px ;line-height: 150%;font-weight: 400;">
											浙江星链数据科技有限公司（简称星链数据）将互联网、大数据、云计算、人工智能等新一代信息技术与制造业、零售业深度融合，探索C2M
											智能定制平台模式，为鞋业从制造端到零售终端的全产业链赋能，助力鞋企由标准化批量生产向个性化按需生产转变。 </div>
										<div class="cc"
											style="font-size: 11px; color: #999999; background-color: #F8F8F8; margin-left: auto; margin-right: auto; height: 30px;width: 78px; border: 1px solid #999999;">
											行业资讯
										</div>
									</div>
								</div>
							</div>
						</transition>
						<div style="width: 10px;height: 1px;"></div>
						<transition name="adfadey1">
							<div v-if="newsshow4" style="margin-bottom: 30px;">
								<div class="boxshadow" style="height: 463px;width: 310px;"
									v-on:click="gopage('/news/details/4')">
									<div>
										<img style="width: 100%; height:210px;" src="../static/news/星链C2M赋能鞋业突围.png">
									</div>
									<div style="padding: 18px 38px 18px 38px;">
										<div class="line-clamp2"
											style="font-size: 16px;color: #333333;  text-align: center;margin-bottom:14px ;font-weight: bold;line-height:24px">
											星链联合华为共同助力中国时尚产业数字化</div>
										<div class="line-clamp3"
											style="font-size: 14px; color: #666666; margin-bottom:30px ;line-height: 150%;font-weight: 400;">
											2022年1月7日上午，浙江星链数据科技有限公司与华为云计算技术有限公司在深圳华为总部签署了“AI数字时尚产业联合创新项目合作协议”，双方通过运用互联网、AI大数据、人工智能技术，基于华为云AI盘古大模型技术和星链C2M数字化产业解决方案，为传统产业提供数字化整体解决方案，助力时尚产业数字化发展，共同构建数字时尚产业互联网新生态
										</div>
										<div class="cc"
											style="font-size: 11px; color: #999999; background-color: #F8F8F8; margin-left: auto; margin-right: auto; height: 30px;width: 78px; border: 1px solid #999999;">
											行业资讯
										</div>
									</div>
								</div>
							</div>
						</transition>
					</div>
				<!-- </div> -->

			</Adword>
		</div>
		<!-- new end-->

		<!--合作伙伴  -->
		<Adword title="生态合作伙伴" slotheight="280" style="background-color: #1D1F29;color: white;">
			<div class="container">
				<div class="row">
					<div class="col-md-2" style="height: 100px; ">
						<img style="height: 100px;background-color: wheat;" src="../static/logo/kizik.png" />
					</div>
					<div class="col-md-2" style="height: 100px; ">
						<img style="height: 100px;background-color: wheat;" src="../static/logo/奥康.png" />
					</div>
					<div class="col-md-2" style="height: 100px; ">
						<img style="height: 100px;background-color: wheat;" src="../static/logo/华为.png" />
					</div>
					<div class="col-md-2" style="height: 100px; ">
						<img style="height: 100px;background-color: wheat;" src="../static/logo/乐步.png" />
					</div>
					<div class="col-md-2" style="height: 100px; ">
						<img style="height: 100px;background-color: wheat;" src="../static/logo/欧文斯.png" />
					</div>
					<div class="col-md-2" style="height: 100px; ">
						<img style="height: 100px;background-color: wheat;" src="../static/logo/知衣.png" />
					</div>

				</div>
				<div style="height: 20px;"></div>
				<div class="row">
					<div class="col-md-2" style="height: 100px; ">
						<img style="height: 100px;background-color: wheat;" src="../static/logo/三体.png" />
					</div>
					<div class="col-md-2" style="height: 100px; ">
						<img style="height: 100px;background-color: wheat;" src="../static/logo/易麦斯.png" />
					</div>



				</div>
			</div>

		</Adword>
		<!--合作伙伴end  -->
	</div>
</template>

<script>
	import firstsceen from '../components/firstsceen.vue'
	import Adbigwordbutton from '../components/adBigWordButton.vue'
	import Adword from '../components/adword.vue'
	export default {
		name: 'index',
		components: {
			firstsceen,
			Adbigwordbutton,
			Adword
		},
		data() {
			return {
				// C2M智能定制解决方案
				img1: require('../static/C2M智能定制解决方案.png'),
				img2: require('../static/ai流行趋势图片.png'),
				img3: require('../static/数字化材料图书馆.png'),
				img4: require('../static/数字成就美好生活图片.png'),



				bakimg1: require('../static/ad1.png'),
				bakimg2: require('../static/工业互联网图.png'),
				bakimg3: require('../static/ai辅助设计平台图.png'),
				bakimg4: require('../static/手持3D数据扫描图.png'),

				scrolltop: 0,
				vscrolltop: 0,

				fouradtop: -1,
				fouradshow: false,
				fouradshow2: false,
				fouradshow3: false,

				newstop: -1,
				newsshow1: false,
				newsshow2: false,
				newsshow3: false,
				newsshow4: false,
			}
		},
		mounted() {
 
			window.addEventListener('scroll', this.scrollHandle); //绑定页面滚动事件

			this.fouradtop = this.$refs.fourad.offsetTop
			this.newstop = this.$refs.news.offsetTop

		},
		methods: {
			gorul:function(url){
				window.location.href = url
			},
			scrollHandle: function(e) {
				var _this = this
				this.scrolltop = e.srcElement.scrollingElement.scrollTop; // 获取页面滚动高度
				//实际高度太晚了，所以要加上一个虚拟高度
				this.vscrolltop = document.documentElement.clientHeight / 4 + this.scrolltop
				//显示4ad
				if (!this.fouradshow) {
					if (this.vscrolltop > this.fouradtop) {
						this.fouradshow = true;

						setTimeout(() => {
							_this.fouradshow2 = true
						}, 400);
						setTimeout(() => {
							_this.fouradshow3 = true
						}, 800);
					}
				}
				//显示news
				if (!this.newsshow1) {
					if (this.vscrolltop > this.newstop) {
						this.newsshow1 = true;

						setTimeout(() => {
							_this.newsshow2 = true
						}, 100);
						setTimeout(() => {
							_this.newsshow3 = true
						}, 200);
						setTimeout(() => {
							_this.newsshow4 = true
						}, 300);
					}
				}
			},
			gopage: function(url) {
				var _this = this
				this.$router.push(url)

				//回到顶部
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
			},

		},

	}
</script>

<style>
	.adsmalltitleview {
		padding: 30px 38px 30px 38px;

	}

	.adsmalltitle {
		font-size: 28px;
		letter-spacing: 5px;
		font-weight: bold;
	}

	.adfadex1-enter-active {
		transition: all 1s;
	}

	.adfadex1-enter {
		opacity: 0;
		transform: translateX(-50px);
	}

	.adfadex2-enter-active {
		transition: all 1s;
	}

	.adfadex2-enter {
		opacity: 0;
		transform: translateX(50px);
	}


	.adfadey1-enter-active {
		transition: all 0.5s;
	}

	.adfadey1-enter {
		opacity: 0;
		transform: translateY(50px);
	}
</style>
